import { sendHDMCreateAccountCompleteEvent } from '@/data/events/handlers/gtm/HDMCreateAccountComplete';
import { HDMUserActionCompletePayload } from '@/data/types/HDMGTM';

export const hdmCreateAccountCompleteDelegator = async (payload: HDMUserActionCompletePayload) => {
	if (payload) {
		await sendHDMCreateAccountCompleteEvent(payload);
	}
};
